import { TextareaAutosize } from "@mui/material";
import { styled, SxProps } from "@mui/material/styles";
import { ChangeEvent } from "react";

const CustomTextarea = styled(TextareaAutosize)(({ theme }) => ({
  "&:focus-visible": {
    outline: `2px solid ${theme.palette.primary.dark}`,
  },
  outline: "none",
  border: "none",
  resize: "vertical",
  fontFamily: "Plus Jakarta Sans Variable, sans-serif",
  fontSize: 16,
  lineHeight: 1.5,
}));

interface TextareaProps {
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  value: string;
  placeholder?: string;
  minRows?: number;
  sx?: SxProps;
}

export const Textarea = ({
  onChange,
  value,
  placeholder,
  minRows,
  sx,
}: TextareaProps) => {
  return (
    <CustomTextarea
      sx={{
        p: 2,
        bgcolor: "#F2F2F2",
        borderRadius: 2,
        width: "100%",
        ...sx,
      }}
      minRows={minRows}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
    />
  );
};
